'use client';
import dynamic from 'next/dynamic';

const HeroSectionClient = dynamic(
  () => import('@/components/home/HeroSection/HeroSection'),
  {
    ssr: false,
  }
);

export default HeroSectionClient;
